import React, { FunctionComponent, useEffect, useRef, useState } from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme/ScopedTheme';
import { useSelector } from 'react-redux';

import { Drawer } from '../../../components';
import { i18n } from '../../../helpers/i18n';
import { selectIsCalendarSummarizationFeatureEnabled } from '../../flags/selectors';
import { SettingsMenu } from '../components/menu';
import type { SettingsComponentProps } from '../types';
import css from './styles.css';

export const SettingsMobile: FunctionComponent<SettingsComponentProps> = ({
    visible = true,
    onClose,
    availableMenuItems,
    selectedItem,
    setSelectedItem,
    parentRef,
}) => {
    const [lastSelectedItem, setLastSelectedItem] = useState(selectedItem);
    const drawerRef = useRef<HTMLDivElement>(null);
    const isCalendarSummarizationFeatureEnabled = useSelector(selectIsCalendarSummarizationFeatureEnabled);

    useEffect(() => {
        if (selectedItem) {
            setLastSelectedItem(selectedItem);
        }
    }, [selectedItem]);

    return (
        <ScopedTheme theme="dark">
            <Drawer
                scope={parentRef}
                onClose={onClose}
                visible={visible}
                titleComponent={<h1 className={css.drawerHeader}>{i18n('settings', 'title')}</h1>}
                keepMounted={false}
            >
                <div className={css.contentContainer}>
                    <SettingsMenu
                        menuItems={availableMenuItems}
                        selectedItem={null}
                        onSelectedItemChange={setSelectedItem}
                    />
                    <ScopedTheme theme="dark" force>
                        <Drawer
                            nested
                            scope={parentRef}
                            innerRef={drawerRef}
                            onCloseEnd={() => setLastSelectedItem(null)}
                            onClose={() => setSelectedItem(null)}
                            visible={Boolean(selectedItem)}
                            titleComponent={
                                <h1 className={css.drawerHeader}>
                                    {lastSelectedItem?.contentTitle?.(isCalendarSummarizationFeatureEnabled) ||
                                        lastSelectedItem?.title()}
                                </h1>
                            }
                        >
                            <div className={css.content}>
                                {lastSelectedItem && (
                                    <lastSelectedItem.section drawerRef={drawerRef} parentRef={parentRef} />
                                )}
                            </div>
                        </Drawer>
                    </ScopedTheme>
                </div>
            </Drawer>
        </ScopedTheme>
    );
};
